var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6414_2992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83789 19.5044H14.4727V12.395C14.4727 11.9458 14.1797 11.6528 13.7305 11.6528H9.58984C9.13086 11.6528 8.83789 11.9458 8.83789 12.395V19.5044ZM5.01953 20.5103H18.2324C19.6191 20.5103 20.4297 19.7192 20.4297 18.3521V7.56104L18.8574 6.48682V17.9517C18.8574 18.5864 18.5156 18.938 17.9004 18.938H5.35156C4.72656 18.938 4.38477 18.5864 4.38477 17.9517V6.49658L2.8125 7.56104V18.3521C2.8125 19.7192 3.62305 20.5103 5.01953 20.5103ZM0 9.64111C0 10.0415 0.3125 10.4224 0.839844 10.4224C1.11328 10.4224 1.33789 10.2759 1.54297 10.1099L11.3184 1.90674C11.5332 1.71143 11.7969 1.71143 12.0117 1.90674L21.7871 10.1099C21.9824 10.2759 22.207 10.4224 22.4805 10.4224C22.9395 10.4224 23.3105 10.1392 23.3105 9.67041C23.3105 9.37744 23.2129 9.18213 23.0078 9.00635L12.8418 0.461426C12.1191 -0.153809 11.2207 -0.153809 10.4883 0.461426L0.3125 9.00635C0.0976562 9.18213 0 9.4165 0 9.64111ZM17.9785 5.23682L20.4297 7.30713V2.79541C20.4297 2.36572 20.1562 2.09229 19.7266 2.09229H18.6816C18.2617 2.09229 17.9785 2.36572 17.9785 2.79541V5.23682Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6414_2992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3105,
    height: 22.1631,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarHome);
export default __webpack_public_path__ + "static/media/tabbar-home.501a0e90a6d3ce0c733365018bcb6208.svg";
export { ForwardRef as ReactComponent };